var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Otp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.59998 10C5.59998 9.10004 5.84998 8.25004 6.34998 7.55004C6.84998 6.80004 7.54998 6.25004 8.34998 5.90004C9.14998 5.55004 10.05 5.50004 10.9 5.65004C11.75 5.80004 12.55 6.25004 13.2 6.85004C13.85 7.45004 14.25 8.25004 14.4 9.15004C14.55 10 14.5 10.9 14.15 11.7C13.8 12.5 13.25 13.2 12.5 13.7C11.75 14.2 10.9 14.45 10.05 14.45C8.84998 14.45 7.74998 14 6.89998 13.15C6.04998 12.3 5.59998 11.2 5.59998 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1 4.4001C13.1 3.9001 13.25 3.4001 13.55 3.0001C13.85 2.6001 14.25 2.2501 14.7 2.0501C15.15 1.8501 15.7 1.8001 16.15 1.9001C16.65 2.0001 17.1 2.2501 17.45 2.6001C17.8 2.9501 18.05 3.4001 18.15 3.9001C18.25 4.4001 18.2 4.9001 18 5.3501C17.8 5.8001 17.5 6.2001 17.05 6.5001C16.65 6.8001 16.15 6.9501 15.65 6.9501C14.95 6.9501 14.35 6.7001 13.85 6.2001C13.4 5.7001 13.1 5.0501 13.1 4.4001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 10C0 7.35 1.05 4.8 2.95 2.95C4.8 1.05 7.35 0 10 0V3.65C8.75 3.65 7.5 4 6.45 4.7C5.4 5.4 4.6 6.4 4.1 7.55C3.6 8.7 3.5 10 3.75 11.25C4 12.5 4.6 13.65 5.5 14.5C6.4 15.4 7.55 16 8.8 16.25C10.05 16.5 11.35 16.35 12.5 15.85C13.65 15.35 14.65 14.55 15.35 13.5C16.05 12.45 16.4 11.2 16.4 9.95H20C20 11.25 19.75 12.55 19.25 13.8C18.75 15 18 16.1 17.1 17.05C16.15 18 15.05 18.7 13.85 19.2C12.65 19.7 11.35 20 10 20C8.7 20 7.4 19.75 6.15 19.25C4.95 18.75 3.85 18 2.9 17.1C1.95 16.15 1.25 15.05 0.75 13.85C0.25 12.6 0 11.3 0 10Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.275b11597a7585c1321f30da07d8da2f.svg";
export { ForwardRef as ReactComponent };